import { useQuery } from '@tanstack/react-query'

import { getForm as apiGetForm } from '@fullfabric/public-api'

/**
 * Fetches the data for a FF Form.
 *
 * @param {String} formId ID for the form to fetch
 * @param {Object} [queryOpts] Options for the query, forwarded to `react-query`
 * @returns {Object} Object containing the form, a loading status bool, an error
 *                   status bool, and the request ID from the response headers.
 */
export default function useFormQuery(formId, queryOpts = {}) {
  const { data, status } = useQuery({
    queryKey: ['get-form', formId],
    queryFn: async () => await apiGetForm(formId, queryOpts)
  })

  return {
    form: data || {},
    loading: status === 'pending',
    errored: status === 'error'
  }
}
